import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "fc9b8717-7978-4b84-b20f-6091d6f44c35",
  publicId: "13",
  name: "Spherical wave and Pulsating sphere",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: true },
  body: [principle01, task01],
};

export default lesson;
